<script lang="ts">
  import { onMount } from 'svelte';
  import { login } from '../lib/auth.svelte';
  import {
    clinicPreview,
    orgFromDemoSlug,
    demoTenantForOrg,
    demoAdminUser,
    type ClinicPreviewOrg,
  } from '../lib/clinic-preview.svelte';
  import { DEMO_SEED_KEY } from '../lib/demo-seed-shared';
  import { FISIO_DEMO_EVAL_TAB_KEY } from '../lib/clinic-demo-seed';
  import { clearTenantContext } from '../lib/tenant.svelte';

  const REGISTRO = 'https://clinica-privada.com/registro?plan=clinica-solo';

  let slug = $state('');
  let org = $state<ClinicPreviewOrg | null>(null);
  let loading = $state(false);
  let error = $state<string | null>(null);

  const LABELS: Record<string, { emoji: string; title: string }> = {
    medica: { emoji: '🩺', title: 'Clínica médica' },
    odonto: { emoji: '🦷', title: 'Odontología' },
    vet: { emoji: '🐾', title: 'Veterinaria' },
    nutricion: { emoji: '🥗', title: 'Nutrición' },
    psico: { emoji: '🧠', title: 'Psicología' },
    estetica: { emoji: '✨', title: 'Estética' },
    optica: { emoji: '👓', title: 'Óptica' },
    fisio: { emoji: '🏃', title: 'Fisioterapia' },
  };

  onMount(() => {
    const m = location.pathname.match(/\/demo\/clinica\/([\w-]+)/);
    slug = m?.[1] ?? 'medica';
    org = orgFromDemoSlug(slug);
    if (org) clinicPreview.org = org;
    void entrarDemo();
  });

  async function entrarDemo() {
    loading = true;
    error = null;
    try {
      const tenantId = demoTenantForOrg(org);
      const usuario = demoAdminUser(tenantId);
      if (org) clinicPreview.org = org;
      sessionStorage.removeItem(DEMO_SEED_KEY);
      if (org === 'clinica-fisioterapia') {
        try { sessionStorage.setItem(FISIO_DEMO_EVAL_TAB_KEY, '1'); } catch { /* ignore */ }
      }
      clearTenantContext();
      await login(tenantId, usuario, 'Demo-Toscana-2026');
      if (org) clinicPreview.org = org;
      location.replace('/');
      // El seed corre en ClinicPreviewBar al cargar el dashboard (no bloquea la entrada).
    } catch (e: any) {
      const msg = e?.message ?? String(e);
      error = msg.includes('direct access grants') || msg.includes('unauthorized_client')
        ? 'No se pudo conectar la demo (login Keycloak). Reintente en unos segundos o use Iniciar sesión con clinica-demo-*@toscanasystems.com / Demo-Toscana-2026'
        : msg;
    } finally {
      loading = false;
    }
  }

  const meta = $derived(LABELS[slug] ?? LABELS.medica);
</script>

<div class="wrap">
  <div class="card">
    <span class="emoji">{meta.emoji}</span>
    <h1>Demo · {meta.title}</h1>
    <p>Entrando a la app… los datos demo se cargan en segundo plano.</p>
    {#if loading}<p class="muted">Conectando demo…</p>{/if}
    {#if error}
      <p class="err">{error}</p>
      <button type="button" onclick={entrarDemo}>Reintentar</button>
      <p class="muted">También puede <a href={REGISTRO}>registrarse gratis 30 días</a>.</p>
    {/if}
  </div>
</div>

<style>
  .wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 2rem; background: linear-gradient(135deg, #E6FAFB, #fff); }
  .card { max-width: 420px; text-align: center; background: #fff; border-radius: 1rem; padding: 2rem; border: 2px solid #2D9C9C; box-shadow: 0 12px 32px rgba(45,156,156,.15); }
  .emoji { font-size: 3rem; display: block; margin-bottom: 0.5rem; }
  h1 { margin: 0 0 0.5rem; color: #005F73; font-size: 1.35rem; }
  p { margin: 0.35rem 0; color: #4b5563; }
  .muted { font-size: 0.88rem; color: #6b7280; }
  .err { color: #b00020; }
  button { margin-top: 1rem; padding: 0.65rem 1.2rem; border: 0; border-radius: 8px; background: #2D9C9C; color: #fff; font-weight: 700; cursor: pointer; }
  a { color: #0f766e; }
</style>
